
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Record } from './record';
import { RecordLink } from '../record-link/record-link';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const RecordsQuery = require('./gql/records.query.gql');
const RecordQuery = require('./gql/record.query.gql');
const RecordFromLinkQuery = require('./gql/record-from-link.query.gql');

export interface RecordsQueryResult {
  records: Record[]
  recordsCount: number
}

export type RecordOrderBy = 'NAME';
export type RecordOrderByDirection = 'ASC' | 'DESC';

export class RecordFilter {
  offset: number
  limit: number

  search = '';
  order_by: RecordOrderBy = 'NAME';
  order_direction: RecordOrderByDirection = 'ASC';
  start_date = '0';
  end_date = '0';
}

/**
 * Service to manage records
 */
@Injectable()
export class RecordService {

  constructor(private apollo: Apollo) { }

  records(filter: RecordFilter): Observable<RecordsQueryResult> {
    return this.apollo
      .query({
        query: RecordsQuery,
        variables: {
          filter
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        let recordsData = result.data['records'];
        let recordsCount = result.data['recordsCount'];

        let records = _map(recordsData, recordData => new Record(recordData));

        return {
          records,
          recordsCount
        };
      }));
  }

  record(id: string): Observable<Record> {
    return this.apollo
      .query({
        query: RecordQuery,
        variables: {
          id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => new Record(result.data['record'])));
  }

  recordFromLink(dossier_id: string, link_id: string): Observable<RecordLink> {
    return this.apollo
      .query({
        query: RecordFromLinkQuery,
        variables: {
          dossier_id,
          link_id,
          link_type: 'RecordLink'
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => new RecordLink(result.data['dossier']['link'])));
  }
}